export const auctionDonorsStyle = {
	title: {
		textAlign: 'center',
		marginBottom: '4px',
	},

	button: {
		padding: '10px 16px',
	},
};
